module.exports = __webpack_public_path__ + "media/images/gift/steps/couple-39ff16a00756eadf0e39cc7be4f393de.png";